import {
  Component,
  OnInit,
  signal,
  ChangeDetectionStrategy,
} from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { JoinOpenAppointmentDialogComponent } from '../join-open-appointment-dialog/join-open-appointment-dialog.component';
import { InquiryOpen } from '../../model/inquiry/InquiryOpen';
import {
  AppointmentMessageType,
  AppointmentMessagingService,
} from '../../services/signaling/messaging/appointment-messaging.service';
import { MatDialog } from '@angular/material/dialog';
import { InquiryDashboardService } from '../../services/api/inquiry-dashboard.service';
import { NavigationService } from '../../services/util/navigation.service';
import { finalize, Observable, tap } from 'rxjs';

@Component({
  selector: 'app-join-open-appointment-button',
  imports: [MatButton, MatIcon],
  templateUrl: './join-open-appointment-button.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './join-open-appointment-button.component.scss',
})
export class JoinOpenAppointmentButtonComponent implements OnInit {
  private static readonly MAX_DAYS_PRIOR = 3;

  protected openInquiries$ = signal<InquiryOpen[]>([]);
  protected refreshing$ = signal(false);

  constructor(
    private readonly inquiryService: InquiryDashboardService,
    private readonly appointmentSignalingService: AppointmentMessagingService,
    private readonly navigationService: NavigationService,
    private readonly dialog: MatDialog,
  ) {
    this.appointmentSignalingService
      .onMessage(AppointmentMessageType.Start)
      .subscribe(() => {
        this.checkForOpenInquiries();
      });

    this.appointmentSignalingService
      .onMessage(AppointmentMessageType.Hang_Up)
      .subscribe(() => {
        this.checkForOpenInquiries();
      });
  }

  ngOnInit(): void {
    this.checkForOpenInquiries();
  }

  joinRunningAppointment() {
    if (this.refreshing$()) {
      return;
    }

    this.refreshing$.set(true);
    this.loadOpenInquiries()
      .pipe(finalize(() => this.refreshing$.set(false)))
      .subscribe({
        next: (inquiries) => this.openJoinableAppointments(inquiries),
      });
  }

  private openJoinableAppointments(inquiries: InquiryOpen[]): void {
    if (inquiries.length === 1 && inquiries[0].inquiryIdentifier) {
      this.navigationService.navigateToVideoAppointment(
        inquiries[0].inquiryIdentifier,
        true,
        inquiries[0].videoAppointmentIdentifier,
      );
    } else if (inquiries.length > 1) {
      this.dialog.open(JoinOpenAppointmentDialogComponent, {
        data: { inquiries },
      });
    }
  }

  private checkForOpenInquiries(): void {
    this.loadOpenInquiries().subscribe();
  }

  private loadOpenInquiries(): Observable<InquiryOpen[]> {
    return this.inquiryService
      .getOpenInquiries(JoinOpenAppointmentButtonComponent.MAX_DAYS_PRIOR)
      .pipe(tap((inquiries) => this.openInquiries$.set(inquiries)));
  }
}
